import OptimizelyFeatureFlaggedComponent from "@/src/components/OptimizelyFeatureFlaggedComponent";
import { OptimizelyFeatureFlags } from "@/src/services/optimizely/optimizelyFeatureFlags";
import Table from "@/src/components/Table";
import QueryLoadingWrapper from "@/src/components/QueryLoadingWrapper";
import { useProductDetailsTabTableData } from "../hooks";
import clsx from "clsx";
import { TableTheme } from "@/src/components/Table/types";
import {
  DETAILS_TAB_HEADER_DETAILS,
  DETAILS_TAB_HEADER_VALUE,
  getDetailsTabTokenMetadataRows,
  getRowsWithTooltips,
} from "./TokenProperties/helpers";
import { TokenMetadataType } from "@/src/types";

type Props = {
  productName: string;
  className?: string;
  tokenMetadata: TokenMetadataType;
};

const AlchemyData: React.FC<Props> = ({
  productName,
  className,
  tokenMetadata,
}) => {
  const detailsTableHeaders = [
    { value: DETAILS_TAB_HEADER_DETAILS },
    { value: DETAILS_TAB_HEADER_VALUE, isHidden: true },
  ];

  const detailsTabTableDataRows = useProductDetailsTabTableData(productName);

  const tokenMetadataRows =
    tokenMetadata?.rarity && getDetailsTabTokenMetadataRows(tokenMetadata);

  const isTableDataDefined =
    detailsTabTableDataRows !== undefined && tokenMetadataRows !== undefined;

  const rows = isTableDataDefined && [
    ...detailsTabTableDataRows,
    ...tokenMetadataRows,
  ];

  // Adds tooltip copy to rows that have tooltips
  const tooltipRows = rows && getRowsWithTooltips(rows);

  return (
    <div className={clsx(className)}>
      <OptimizelyFeatureFlaggedComponent
        optimizelyFlags={[OptimizelyFeatureFlags.ALCHEMY]}
      >
        <QueryLoadingWrapper isLoading={!isTableDataDefined}>
          {isTableDataDefined && tooltipRows && (
            <Table
              headers={detailsTableHeaders}
              rows={tooltipRows}
              theme={TableTheme.dark}
            />
          )}
        </QueryLoadingWrapper>
      </OptimizelyFeatureFlaggedComponent>
    </div>
  );
};

export default AlchemyData;
